import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "./i18n";  // Import i18n configuration
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// 🔹 ResizeObserver hatalarını tamamen bastır
const resizeObserverErr = /(ResizeObserver loop limit exceeded|ResizeObserver loop completed)/;
const originalError = console.error;
console.error = (...args) => {
  if (args.length > 0 && resizeObserverErr.test(args[0])) {
    return; // sessiz geç
  }
  originalError(...args);
};

// 🔹 Global fetch interceptor – 401 gelirse otomatik logout
const _originalFetch = window.fetch;
window.fetch = async function (...args) {
  const response = await _originalFetch(...args);
  if (response.status === 401) {
    // /login endpoint'inin kendisi 401 döndürebilir (yanlış şifre), onu atla
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url ?? "";
    if (!url.includes("/customers/login")) {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      window.dispatchEvent(new Event("auth:logout"));
    }
  }
  return response;
};

window.addEventListener("error", (e) => {
  if (e.message?.includes("ResizeObserver")) e.stopImmediatePropagation();
});
window.addEventListener("unhandledrejection", (e) => {
  if (e.reason?.message?.includes("ResizeObserver")) e.stopImmediatePropagation();
});

// 🔹 StrictMode kaldırıldı → ResizeObserver hatası tamamen gider
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
